import React, { MouseEvent } from 'react';
import classNames from 'classnames';
import './row.scss';

const TableRow: React.FC<{
  id?: string;
  customClass?: string;
  onClick?: (event: MouseEvent) => void;
  onMouseDown?: (event: MouseEvent) => void;
  onMouseUp?: (event: MouseEvent) => void;
  onDoubleClick?: (event: MouseEvent) => void;
  needAnimate?: boolean;
  isBordered?: boolean;
  status?: string;
}> = ({ customClass, needAnimate, status, ...rest }) => {
  const animationClass =
    status === 'error'
      ? 'ui-table__row_animate-error'
      : 'ui-table__row_animate-success';

  return (
    <div
      className={classNames('ui-table__row ', customClass, {
        [animationClass]: needAnimate,
      })}
      {...rest}
    />
  );
};

export default TableRow;
